<template>
    <div class="personal-materials-info">
        <div>
            <div class="shadow">
                <div style="display: flex;align-items: flex-end;">
                    <span class="d-title">个人材料信息</span>
                    <span style="flex: 1;text-align: right;" class="d-edit" @click="isEdit = !isEdit">编辑</span>
                </div>
                <div style="margin-top: 0.2rem;">
                    <div style="background-color: #909399;height: 1px;width: 100%;"></div>
                </div>
                <div style="margin-top: 0.2rem;" id="b-content">
                    <div v-if="!isEdit" style="padding: 0.1rem 0 0.1rem 0;">
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">身份证(人像面):</el-col>
                            <el-col :span="7" class="col-n col">
                                <el-image v-if="personalMaterialsInfoForm.amic_front.preview_url.length > 0"
                                    style="width:1rem;height:3rem"
                                    :src="personalMaterialsInfoForm.amic_front.preview_url[0].url"
                                    :preview-src-list="[personalMaterialsInfoForm.amic_front.preview_url[0].url]">
                                </el-image>
                            </el-col>
                            <el-col :span="5" class="col">身份证(国徽面):</el-col>
                            <el-col :span="7" class="col-n col">
                                <el-image v-if="personalMaterialsInfoForm.amic_back.preview_url.length > 0"
                                    style="width:1rem;height:3rem"
                                    :src="personalMaterialsInfoForm.amic_back.preview_url[0].url"
                                    :preview-src-list="[personalMaterialsInfoForm.amic_back.preview_url[0].url]">
                                </el-image>
                            </el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">学历证书:</el-col>
                            <el-col :span="7" class="col-n col">
                                <el-image v-if="personalMaterialsInfoForm.am_education.preview_url.length > 0"
                                    style="width:1rem;height:3rem"
                                    :src="personalMaterialsInfoForm.am_education.preview_url[0].url"
                                    :preview-src-list="[personalMaterialsInfoForm.am_education.preview_url[0].url]">
                                </el-image>
                            </el-col>
                            <el-col :span="5" class="col">学位证书:</el-col>
                            <el-col :span="7" class="col-n col">
                                <el-image v-if="personalMaterialsInfoForm.am_degree.preview_url.length > 0"
                                    style="width:1rem;height:3rem"
                                    :src="personalMaterialsInfoForm.am_degree.preview_url[0].url"
                                    :preview-src-list="[personalMaterialsInfoForm.am_degree.preview_url[0].url]">
                                </el-image>
                            </el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">前公司离职证明:</el-col>
                            <el-col :span="7" class="col-n col">
                                <el-image v-if="personalMaterialsInfoForm.am_separation_certificate.preview_url.length > 0"
                                    style="width:1rem;height:3rem"
                                    :src="personalMaterialsInfoForm.am_separation_certificate.preview_url[0].url"
                                    :preview-src-list="[personalMaterialsInfoForm.am_separation_certificate.preview_url[0].url]">
                                </el-image>
                            </el-col>
                            <el-col :span="5" class="col">员工照片:</el-col>
                            <el-col :span="7" class="col-n col">
                                <el-image v-if="personalMaterialsInfoForm.am_photo.preview_url.length > 0"
                                    style="width:1rem;height:3rem"
                                    :src="personalMaterialsInfoForm.am_photo.preview_url[0].url"
                                    :preview-src-list="[personalMaterialsInfoForm.am_photo.preview_url[0].url]">
                                </el-image>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-else>
                        <el-form ref="personalMaterialsInfoForm" :model="personalMaterialsInfoForm" label-width="115px"
                            size="medium">
                            <!-- :file-list="personalMaterialsInfoForm.amic_front.url" -->
                            <el-form-item label="身份证(人像面)">
                                <el-upload :action="uploadUrl" ref="amic_front" :data="{ path: 'amic_front' }"
                                    :headers="header" :on-remove="handleRemove" :on-success="handleUploadSuccess"
                                    :before-upload="beforeUpload" :limit="1" list-type="picture"
                                    :file-list="personalMaterialsInfoForm.amic_front.preview_url">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                    <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="身份证(国徽面)">
                                <el-upload :action="uploadUrl" ref="amic_back" :data="{ path: 'amic_back' }"
                                    :headers="header" :on-remove="handleRemove" :on-success="handleUploadSuccess"
                                    :before-upload="beforeUpload" :limit="1" list-type="picture"
                                    :file-list="personalMaterialsInfoForm.amic_back.preview_url">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                    <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="学历证书">
                                <el-upload :action="uploadUrl" ref="am_education" :data="{ path: 'am_education' }"
                                    :headers="header" :on-remove="handleRemove" :on-success="handleUploadSuccess"
                                    :before-upload="beforeUpload" :limit="1" list-type="picture"
                                    :file-list="personalMaterialsInfoForm.am_education.preview_url">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                    <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="学位证书">
                                <el-upload :action="uploadUrl" ref="am_degree" :data="{ path: 'am_degree' }"
                                    :headers="header" :on-remove="handleRemove" :on-success="handleUploadSuccess"
                                    :before-upload="beforeUpload" :limit="1" list-type="picture"
                                    :file-list="personalMaterialsInfoForm.am_degree.preview_url">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                    <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="前公司离职证明">
                                <el-upload :action="uploadUrl" ref="am_separation_certificate"
                                    :data="{ path: 'am_separation_certificate' }" :headers="header"
                                    :on-remove="handleRemove" :on-success="handleUploadSuccess"
                                    :before-upload="beforeUpload" :limit="1" list-type="picture"
                                    :file-list="personalMaterialsInfoForm.am_separation_certificate.preview_url">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                    <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="员工照片">
                                <el-upload :action="uploadUrl" ref="am_photo" :data="{ path: 'am_photo' }" :headers="header"
                                    :on-remove="handleRemove" :on-success="handleUploadSuccess"
                                    :before-upload="beforeUpload" :limit="1" list-type="picture"
                                    :file-list="personalMaterialsInfoForm.am_photo.preview_url">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                    <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                                </el-upload>
                            </el-form-item>
                            <el-form-item size="medium">
                                <el-button type="primary" @click="onSubmit">提交</el-button>
                                <el-button @click.native="isEdit = !isEdit">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { common } from '../../../../static/mixins/common'
import { upload } from '../../../../static/mixins/upload'
export default {
    name: 'PersonalMaterialsInfo',
    mixins: [common, upload],
    props: {
        adminuser_id: {
            type: Number
        },
        adminuser_name: {
            type: String
        }
    },
    data() {
        return {
            personalMaterialsInfoForm: {
                amic_front: {
                    origin_name: '',
                    url: '',
                    preview_url: []
                },
                amic_back: {
                    origin_name: '',
                    url: '',
                    preview_url: []
                },
                am_education: {
                    origin_name: '',
                    url: '',
                    preview_url: []
                },
                am_degree: {
                    origin_name: '',
                    url: '',
                    preview_url: []
                },
                am_separation_certificate: {
                    origin_name: '',
                    url: '',
                    preview_url: []
                },
                am_photo: {
                    origin_name: '',
                    url: '',
                    preview_url: []
                },
            },
            header: {
                Authorization: localStorage.getItem('token'),
            },
            isEdit: false,
            adminuserId: '',
            adminuserName: '',
            uploadUrl: process.env.NODE_ENV === 'development' ? 'api/api3_admin_user_uploads_personal_materials' : 'https://weixin.qiyehuo.com/api/api3_admin_user_uploads_personal_materials'
        }
    },
    methods: {
        onSubmit() {
            this.$axios.put('api/api3_update_personal_materials', {
                formData: this.personalMaterialsInfoForm,
                admin_user_id: this.adminuserId
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.$message.success(data.msg)
                    this.showData(data.data)
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        getAdminUserpersonalMaterialsInfo(admin_user_id) {
            this.resetForm()
            this.ysyMAdminPersonalMaterialsInfoOptions = []
            this.ysyMGetAdminUserPersonalMaterialsInfo(admin_user_id)
        },
        resetForm() {
            this.personalMaterialsInfoForm.amic_front.origin_name = ''
            this.personalMaterialsInfoForm.amic_front.url = ''
            this.personalMaterialsInfoForm.amic_front.preview_url = []
            this.personalMaterialsInfoForm.amic_back.origin_name = ''
            this.personalMaterialsInfoForm.amic_back.url = ''
            this.personalMaterialsInfoForm.amic_back.preview_url = []
            this.personalMaterialsInfoForm.am_education.origin_name = ''
            this.personalMaterialsInfoForm.am_education.url = ''
            this.personalMaterialsInfoForm.am_education.preview_url = []
            this.personalMaterialsInfoForm.am_degree.origin_name = ''
            this.personalMaterialsInfoForm.am_degree.url = ''
            this.personalMaterialsInfoForm.am_degree.preview_url = []
            this.personalMaterialsInfoForm.am_separation_certificate.origin_name = ''
            this.personalMaterialsInfoForm.am_separation_certificate.url = ''
            this.personalMaterialsInfoForm.am_separation_certificate.preview_url = []
            this.personalMaterialsInfoForm.am_photo.origin_name = ''
            this.personalMaterialsInfoForm.am_photo.url = ''
            this.personalMaterialsInfoForm.am_photo.preview_url = []
        },
        handleRemove(file, fileList) {
            if (file.response) {
                this.ysyMDelAliOssFile(file.response.url)
            }else{
                // this.ysyMDelAliOssFile(file.path)
                if (file.path) this.delAliOssFile(file.path,file.id,file.type)
            }
        },
        delAliOssFile(path,id,type) {
            this.$axios.get('api/api3_admin_del_ali_oss', {
                params: {
                    path
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.personalMaterialsInfoForm[type].origin_name = ''
                    this.personalMaterialsInfoForm[type].url = ''
                    this.personalMaterialsInfoForm[type].preview_url = []
                    this.delFileInfo(id)
                }
            }).catch()
        },
        delFileInfo(id) {
            this.$axios.put('api/api3_admin_user_del_personal_materials', {
               id
            }).then(({ data }) => {
                if (data.code === 200) {
                    // this.$message.success(data.msg)
                    //
                }else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        beforeUpload(file) {
            if (file.type.substring(0, 5) !== 'image') {
                this.$message.warning('上传格式不对哦!上传图片格式的文件')
                return false
            }

            if (file.size / 1024 / 1024 > 8) {
                this.$message.warning('请上传8M以内的图片!')
                return false
            }
        },
        handleUploadSuccess(res, file) {
            if (res['code'] === 1) {
                this.personalMaterialsInfoForm[res['key']].origin_name = res['originName']
                this.personalMaterialsInfoForm[res['key']].url = res['url']
            } else {
                this.$refs[res['key']].clearFiles()
                this.$message.error(res['msg'])
            }
        },
        showData(data) {
            data.map(item => {
                if (item.type === 'amic_front') {
                    this.personalMaterialsInfoForm.amic_front.origin_name = item.origin_name
                    this.personalMaterialsInfoForm.amic_front.url = item.url
                    if (item.oss_path) {
                        this.personalMaterialsInfoForm.amic_front.preview_url = [{
                            name: item.origin_name,
                            url: item.oss_path,
                            path: item.url,
                            id: item.id,
                            type: item.type
                        }]
                    }
                } else if (item.type === 'amic_back') {
                    this.personalMaterialsInfoForm.amic_back.origin_name = item.origin_name
                    this.personalMaterialsInfoForm.amic_back.url = item.url
                    if (item.oss_path) {
                        this.personalMaterialsInfoForm.amic_back.preview_url = [{
                            name: item.origin_name,
                            url: item.oss_path,
                            path: item.url,
                            id: item.id,
                            type: item.type
                        }]
                    }
                } else if (item.type === 'am_education') {
                    this.personalMaterialsInfoForm.am_education.origin_name = item.origin_name
                    this.personalMaterialsInfoForm.am_education.url = item.url
                    if (item.oss_path) {
                        this.personalMaterialsInfoForm.am_education.preview_url = [{
                            name: item.origin_name,
                            url: item.oss_path,
                            path: item.url,
                            id: item.id,
                            type: item.type
                        }]
                    }
                } else if (item.type === 'am_degree') {
                    this.personalMaterialsInfoForm.am_degree.origin_name = item.origin_name
                    this.personalMaterialsInfoForm.am_degree.url = item.url
                    if (item.oss_path) {
                        this.personalMaterialsInfoForm.am_degree.preview_url = [{
                            name: item.origin_name,
                            url: item.oss_path,
                            path: item.url,
                            id: item.id,
                            type: item.type
                        }]
                    }
                } else if (item.type === 'am_separation_certificate') {
                    this.personalMaterialsInfoForm.am_separation_certificate.origin_name = item.origin_name
                    this.personalMaterialsInfoForm.am_separation_certificate.url = item.url
                    if (item.oss_path) {
                        this.personalMaterialsInfoForm.am_separation_certificate.preview_url = [{
                            name: item.origin_name,
                            url: item.oss_path,
                            path: item.url,
                            id: item.id,
                            type: item.type
                        }]
                    }
                } else if (item.type === 'am_photo') {
                    this.personalMaterialsInfoForm.am_photo.origin_name = item.origin_name
                    this.personalMaterialsInfoForm.am_photo.url = item.url
                    if (item.oss_path) {
                        this.personalMaterialsInfoForm.am_photo.preview_url = [{
                            name: item.origin_name,
                            url: item.oss_path,
                            path: item.url,
                            id: item.id,
                            type: item.type
                        }]
                    }
                }
            })
        }
    },
    watch: {
        adminuser_id: {
            immediate: true,
            handler(n, o) {
                this.adminuserId = null
                if (n !== o) {
                    this.adminuserId = n
                    this.getAdminUserpersonalMaterialsInfo(n)
                }
            }
        },
        adminuser_name: {
            immediate: true,
            handler(n, o) {
                if (n !== o) {
                    this.adminuserName = n
                }
            }
        },
        ysyMAdminPersonalMaterialsInfoOptions: {
            handler(n, o) {
                if (n !== o) {
                    if (n) {
                        this.showData(n)
                    }
                }
            },
        },
    }
}
</script>

<style scoped>
.d-title {
    font-size: x-large;
    font-weight: bold;
}

.d-edit {
    font-size: medium;
    font-weight: bold;
    color: #409EFF;
    cursor: pointer;
}

/* .col {
    font-size: larger;
    font-weight: bold;
} */

/* .col-n {
    color: slategrey;
} */

#b-content .el-row {
    margin-bottom: 0.6rem;
}

.shadow {
    padding: 0.3rem 0.6rem;
    border: 1px solid #ccc;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, .3);
    margin: 0.2rem;
}

.over-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

#b-content>>>.el-form-item {
    width: 45% !important;
    display: inline-block !important;
    vertical-align: top !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/authority/UserInfoTab/PersonalMaterialsInfo.vue